<template>
  <div class="rulesCombination">
    <el-dialog
      :visible="isShow && tabIndex === '0'"
      :title="$t('AutomaticRelease.common.combinationTitle')"
      :close-on-click-modal="false"
      :show-close="false"
      width="1000px"
    >
      <div class="app-main-inner-row">
        <div style="width:605px;">
          <el-form label-width="150px" :model="form" :rules="validationRules" @submit.native.prevent>
            <el-form-item :label="$t('AutomaticRelease.dialogRuleName')" class="spacing setStyle" prop="ruleName" :show-message="false">
              <el-input v-model="form.ruleName" :placeholder="$t('AutomaticRelease.RuleNamePlaceholder')" />
            </el-form-item>

            <el-form-item v-show="tabIndex === '0'" :label="$t('AutomaticRelease.selectBranch')" class="spacing">
              <el-select v-model="form.branchId" @change="selectFilterBranch(form.branchId)">
                <el-option
                  v-for="(item, index) in branchList"
                  :key="index"
                  :label="item.code"
                  :value="item.officeId"
                />
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('AutomaticRelease.ruleDescription')" class="spacing">
              <el-input v-model="form.describe" :placeholder="$t('AutomaticRelease.ruleDescriptionPlaceholder')" type="textarea" />
            </el-form-item>

            <span class="businessTypes">{{ $t('AutomaticRelease.AnyRuleTitle') }}</span>

            <el-form-item label-width="0" class="spacing newColumnRule">
              <div v-for="(item, index) in AnyRules" :key="index" class="newColumn" style="width:300px;">
                <el-select v-model="item.AnyName" remote filterable @change="changed('Any', item, index)">
                  <el-option
                    v-for="k in AnyRuleOptions"
                    :key="k.AnyRulesUuid"
                    :label="k.AnyRulesName"
                    :value="k.AnyRulesUuid"
                  />
                </el-select>
                <i v-show="AnyRules.length > 1 || AllRules.length > 0" class="el-icon-minus addIcon" style="margin-left:10px;" @click="deleteRule('Any',item, index)" />
              </div>
            </el-form-item>
            <i v-show="AnyRules.length < ruleList.length" class="el-icon-plus addIcon" style="margin:5px 0 0 125px;" @click="addRule('Any')" />

            <span class="businessTypes">{{ $t('AutomaticRelease.AllRuleTitle') }}</span>

            <el-form-item label-width="0" class="spacing newColumnRule">
              <div v-for="(item, index) in AllRules" :key="index" class="newColumn" style="width:300px;">
                <el-select v-model="item.AllName" remote filterable @change="changed('All', item, index)">
                  <el-option
                    v-for="k in AllRuleOptions"
                    :key="k.AllRulesUuid"
                    :label="k.AllRulesName"
                    :value="k.AllRulesUuid"
                  />
                </el-select>
                <i v-show="AnyRules.length > 0 || AllRules.length > 1" class="el-icon-minus addIcon" style="margin-left:10px;" @click="deleteRule('All',item, index)" />
              </div>
            </el-form-item>
            <i v-show="AllRules.length < ruleList.length" class="el-icon-plus addIcon" style="margin:5px 0 0 125px;" @click="addRule('All')" />

            <span class="businessTypes">{{ $t('AutomaticRelease.PerformRelatedActions') }}</span>
            <div class="action">
              <span class="conditions">{{ $t('AutomaticRelease.meetConditions') }}</span>
              <el-checkbox v-model="form.behaviorStateRelease" :disabled="true" :true-label="1" :false-label="0">{{ $t('AutomaticRelease.meetConditionsRemind') }}</el-checkbox>
            </div>
            <div class="action" style="display:flex;margin-bottom:15px;">
              <span style="display:inline-block;flex-shrink:0;white-space:normal;word-break:break-word;margin-right:10px;" class="conditions">
                {{ $t('AutomaticRelease.dissatisfaction') }}
              </span>
              <div>
                <el-checkbox-group v-model="checkList" @change="statusChange()">
                  <el-checkbox :label="0">{{ $t('AutomaticRelease.runningRules') }}</el-checkbox>
                  <el-checkbox :label="1" style="margin-top:15px;">{{ $t('AutomaticRelease.runningRulesRemind') }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
            <div style="margin-left:50px;color:#999;">
              <p style="margin-bottom:0px;">{{ $t('AutomaticRelease.remark1') }}</p>
              <p style="padding-left:35px;margin-top:5px;">{{ $t('AutomaticRelease.remark2') }}</p>
            </div>
          </el-form>
        </div>
        <div class="customer">
          <span class="businessTypes">{{ $t('AutomaticRelease.applicableCustomers') }}</span>
          <p style="padding-left:20px;">{{ $t('AutomaticRelease.applicableCustomersRemind1') }}</p>
          <p style="padding-left:20px;">{{ $t('AutomaticRelease.applicableCustomersRemind2') }}</p>
          <div class="conditionsType">
            <span class="title">{{ $t('AutomaticRelease.conditionType') }}</span>
            <el-select v-model="conditionType" style="width:450px;" @change="selectCustomer">
              <el-option :label="$t('AutomaticRelease.whole')" :value="0" />
              <el-option :label="$t('AutomaticRelease.blacklist')" :value="1" />
              <el-option :label="$t('AutomaticRelease.EffectiveList')" :value="2" />
            </el-select>
          </div>
          <div v-show="conditionType !== 0" style="margin:10px 0 0 20px;">
            <el-button type="primary" @click="addCustomerEvent">{{ $t('AutomaticRelease.add') }}</el-button>
            <el-button size="mini" type="danger" @click="delCustomEvent">{{ $t('AutomaticRelease.deletes') }}</el-button>
          </div>

          <div style="margin-top:10px;width:350px;">
            <cargo-ag-grid
              config-module="2022072601"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
            />
          </div>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="determine">{{ $t('AutomaticRelease.common.save') }}</el-button>
        <el-button @click="cancel">{{ $t('AutomaticRelease.common.cancel') }}</el-button>
      </span>
    </el-dialog>
    <subscribe-port-push-rule-customer-dialog
      :title="$t('SystemMaintenance.SelectCustomer')"
      :visible.sync="ruleViewVisible"
      :customers="portDataSubscribeConfigCompanyList"
      :branch-id="form.branchId"
      :branch-show="branchShow"
      @saveCallBack="saveCallBackFunc"
      @close="ruleViewVisible=false"
    />
  </div>
</template>
<script>
import SubscribePortPushRuleCustomerDialog from '@/views/cargo/v0/SystemMaintenance/components/SubscribePortPushRuleCustomerDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getGridSelected } from '@/utils/agGrid'
import { releaseDocRuleList, saveReleaseDocRuleGroup, releaseDocRuleGroupDetail, updateReleaseDocRuleGroup } from '@/api/sysManage/baseConfig/putASingleRule'
export default {
  name: 'RulesCombination',
  components: { SubscribePortPushRuleCustomerDialog },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    branchList: {
      type: Array,
      default: null
    },
    tabIndex: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      checkedId: 0,
      branchShow: false,
      validationRules: {
        ruleName: [
          { required: true }
        ]
      },
      checkList: [],
      AnyRules: [],
      AllRules: [],
      AnyRuleOptions: [],
      AllRuleOptions: [],
      ruleList: [],
      ruleViewVisible: false,
      releaseDocRuleGroupRelationVoList: [],
      portDataSubscribeConfigCompanyList: [],
      conditionType: 0, // 适用客户类型
      rowData: [],
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('AutomaticRelease.customerName'),
          field: 'chineseName',
          width: 150
        },
        {
          headerName: this.$t('AutomaticRelease.branchOffice'),
          field: 'branchId',
          width: 150,
          cellRenderer: (params) => {
            let value = ''
            if (!params.value && params.data.officeId) {
              value = params.data.officeId
            } else {
              value = params.value
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', value, 'code')
          }
        }
      ],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500
      },
      form: {
        ruleName: '',
        branchId: 0,
        orderNum: '',
        describe: '',
        uuid: '',
        version: '',
        behaviorStateRelease: 1
      }
    }
  },
  methods: {
    // 新增获取规则列表
    async getRulesList(val) {
      if (val === 'add') {
        this.checkList = [0]
      }
      const data = {
        ruleName: ''
      }
      const res = await releaseDocRuleList(data)
      if (res.ok) {
        res.data.map((item) => {
          this.editorSelectVal('Any', item)
          this.editorSelectVal('All', item)
        })
        this.ruleList = res.data
      }
    },
    // 编辑时进入获取下拉的值转换
    editorSelectVal(type, item) {
      const obj = {}
      if (!this[`${type}Rules`].find((v) => v[`${type}RulesUuid`] === item.uuid)) {
        obj[`${type}Name`] = item.uuid
        obj[`${type}RulesName`] = item.ruleName
        obj[`${type}RulesUuid`] = item.uuid
        this[`${type}RuleOptions`].push({
          ...obj
        })
      }
    },
    // 编辑时传递数据
    async onShow(parameters) {
      this.update = true
      const data = {
        uuid: parameters.uuid
      }
      const res = await releaseDocRuleGroupDetail(data)
      if (res.ok) {
        this.form.ruleName = res.data.ruleGroupName
        this.form.branchId = res.data.officeId
        this.form.orderNum = res.data.orderNum
        this.form.describe = res.data.groupDescription
        this.form.behaviorStateRelease = Number(res.data.behaviorStateRelease)
        this.checkList = [Number(res.data.behaviorStateAccountReceivable)]
        this.portDataSubscribeConfigCompanyList = res.data.releaseDocRuleGroupCompanyVoList
        this.rowData = res.data.releaseDocRuleGroupCompanyVoList
        this.form.uuid = res.data.uuid
        this.form.version = res.data.version
        this.conditionType = res.data.conditionType
        this.releaseDocRuleGroupRelationVoList = res.data.releaseDocRuleGroupRelationVoList
        await this.filterValue(res.data, 'Any', 0)
        await this.filterValue(res.data, 'All', 1)
        this.getRulesList()
      }
    },
    filterValue(data, prefix, conditionType) {
      data.releaseDocRuleGroupRelationVoList.map((item) => {
        if (item.conditionType === conditionType) {
          const obj = {}
          obj[`${prefix}Name`] = item.ruleName
          obj[`${prefix}RulesName`] = item.ruleName
          obj[`${prefix}RulesUuid`] = item.ruleUuid
          obj[`${prefix}version`] = item.version
          this[`${prefix}Rules`].push({
            ...obj
          })
        }
      })
    },
    // 确定
    async determine() {
      let prompt = []
      if (!this.form.ruleName.trim()) {
        prompt.push(this.$t('AutomaticRelease.maintenanceName'))
      }
      if (this.AnyRules.length === 0 && this.AllRules.length === 0) {
        prompt.push(this.$t('AutomaticRelease.rule'))
      }
      if (prompt.length > 0) {
        prompt = prompt.join('、')
        const tips = this.$t('AutomaticRelease.prompt').replace('${prompt}', prompt)
        this.$message.warning(tips)
        return
      }
      const releaseDocRuleGroupRelationVoList = [
        ...this.conversionData(this.AnyRules, 'Any', 0),
        ...this.conversionData(this.AllRules, 'All', 1)
      ]
      this.rowData.forEach((item) => {
        if (!item.officeId) {
          item.officeId = item.branchId
        }
      })
      const data = {
        behaviorStateAccountReceivable: this.checkList[0],
        behaviorStateRelease: Boolean(this.form.behaviorStateRelease),
        conditionType: this.conditionType, // 是否是黑名单，0全部 1黑名单
        officeId: this.form.branchId, // 分公司id
        groupDescription: this.form.describe, // 组合描述
        ruleGroupName: this.form.ruleName, // 组合名称
        uuid: this.form.uuid,
        version: this.form.version,
        releaseDocRuleGroupRelationVoList: releaseDocRuleGroupRelationVoList,
        releaseDocRuleGroupCompanyVoList: this.rowData
      }
      if (this.update) {
        data.orderNum = this.form.orderNum
        // 获取对应id的version
        this.releaseDocRuleGroupRelationVoList.map((item) => {
          data.releaseDocRuleGroupRelationVoList.forEach((v) => {
            if (item.conditionType === v.conditionType && item.ruleUuid === v.ruleUuid) {
              v.version = item.version
            }
          })
        })
      }
      let res = null
      if (this.update) {
        res = await updateReleaseDocRuleGroup(data)
      } else {
        res = await saveReleaseDocRuleGroup(data)
      }
      if (res.ok) {
        this.$message.success(this.$t('AutomaticRelease.successRemind'))
        this.$emit('getList')
        this.cancel()
      }
    },
    conversionData(data, prefix, type) {
      return data.map((item) => {
        return {
          conditionType: type,
          ruleUuid: item[`${prefix}RulesUuid`]
        }
      })
    },
    // 点击加号
    addRule(value) {
      const addArr = this[`${value}RuleOptions`].shift()
      this.ruleList.map((item) => {
        if (item.ruleName === addArr[`${value}RulesName`]) {
          addArr[`${value}Name`] = item.ruleName
          addArr[`${value}RulesUuid`] = item.uuid
        }
      })
      this[`${value}Rules`].push({
        ...addArr
      })
      console.log('this.rules', this[`${value}Rules`])
    },
    // 点击减号
    deleteRule(value, item, index) {
      this[`${value}RuleOptions`].push(item)
      this[`${value}Rules`].splice(index, 1)
      console.log('this[`${value}Rules`]', this[`${value}Rules`])
    },
    // 下拉框选中
    changed(value, item, i) {
      // 选中数据在下拉数据中的位置，用于替换时定位索引
      const index = this[`${value}RuleOptions`].findIndex((v) => {
        return item[`${value}Name`] === v[`${value}RulesUuid`]
      })

      // 选中的下拉框数组
      const checkArr = this.ruleList.filter((v) => {
        return item[`${value}RulesUuid`] === v.uuid
      })
      console.log('AnyRules', this.AnyRules)
      console.log('AllRules', this.AllRules)
      // 被替换掉的数据
      const checkArr1 = this.ruleList.filter((v) => {
        return item[`${value}Name`] === v.uuid
      })
      // 重新设置当前框的值
      this[`${value}Rules`][i][`${value}Name`] = checkArr1[0].ruleName
      this[`${value}Rules`][i][`${value}RulesUuid`] = checkArr1[0].uuid
      this[`${value}Rules`][i][`${value}RulesName`] = checkArr1[0].ruleName
      // 重新设置替换option的数据
      const obj = {}
      obj[`${value}RulesName`] = checkArr[0].ruleName
      obj[`${value}RulesUuid`] = checkArr[0].uuid
      obj[`${value}Name`] = checkArr[0].ruleName
      this[`${value}RuleOptions`].splice(index, 1, obj)
    },
    // 适用客户切换为全部时提醒
    selectCustomer(value) {
      if (value === 0 && this.rowData.length !== 0) {
        this.$confirm(this.$t('AutomaticRelease.toggleReminder'), this.$t('AutomaticRelease.tips'), {
          confirmButtonText: this.$t('AutomaticRelease.yes'),
          cancelButtonText: this.$t('AutomaticRelease.no'),
          type: 'warning'
        }).then(() => {
          this.rowData = []
          this.conditionType = 0
        }).catch(() => {
          this.conditionType = 1
        })
      }
    },
    // 取消
    cancel() {
      this.$emit('cancel', false)
      this.reset()
    },
    // 打开适用客户新增弹窗
    addCustomerEvent() {
      this.ruleViewVisible = true
    },
    // 执行不满足条件单选
    statusChange() {
      if (this.checkList.length > 1 && this.checkList.length !== 0) {
        this.checkList.splice(0, 1)
        this.checkedId = this.checkList[0]
      } else {
        this.checkList.push(this.checkedId)
      }
    },
    // 切换分公司过滤黑名单列表数据
    selectFilterBranch(branchId) {
      if (branchId !== 0 && this.rowData.length !== 0) {
        this.portDataSubscribeConfigCompanyList = this.portDataSubscribeConfigCompanyList.filter((item) => {
          return item.branchId === branchId
        })
        this.rowData = this.portDataSubscribeConfigCompanyList
      }
    },
    reset() {
      this.AnyRules = []
      this.AllRules = []
      this.ruleList = []
      this.AnyRuleOptions = []
      this.AllRuleOptions = []
      this.portDataSubscribeConfigCompanyList = []
      this.rowData = []
      this.checkList = []
      this.conditionType = 0
      this.update = false
      this.form = {
        orderNum: '',
        ruleName: '',
        branchId: 0,
        describe: '',
        uuid: '',
        version: '',
        behaviorStateRelease: 1
      }
    },
    // 弹框确认按钮事件
    saveCallBackFunc(datas) {
      this.portDataSubscribeConfigCompanyList.forEach(eve => {
        datas = datas.filter(item => item.cmpIdx !== eve.cmpIdx)
      })
      for (const c1 of datas) {
        c1.selected = false
        this.portDataSubscribeConfigCompanyList.push({
          cmpIdx: c1.cmpIdx,
          branchId: c1.branchId,
          branchName: ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', c1.branchId, 'code'),
          chineseName: c1.chineseName || '',
          cmpName: c1.chineseName || '',
          cnShortName: c1.cnShortName || '',
          englishName: c1.englishName || ''
        })
      }
      this.applyFilter()
    },
    // 删除客户
    delCustomEvent() {
      if (this.portDataSubscribeConfigCompanyList != null && this.portDataSubscribeConfigCompanyList.length > 0) {
        const selections = getGridSelected(this.gridOptions)
        let uuidList = []
        if (selections && selections.length > 0) {
          selections.forEach(row => {
            const index = this.portDataSubscribeConfigCompanyList.findIndex(c => c.uuid === row.uuid)
            uuidList = Array.from(this.portDataSubscribeConfigCompanyList.filter(c => c.uuid === row.uuid), c => c.uuid)
            if (index > -1) {
              this.portDataSubscribeConfigCompanyList.splice(index, 1)
            }
          })
          uuidList.forEach(eve => {
            this.portDataSubscribeConfigCompanyList.forEach((e) => {
              if (eve === e.uuid) {
                e.actionType = 2
              }
            })
          })
        } else {
          this.$message.warning(this.$t('AutomaticRelease.deleteRemind'))
        }
      }
      this.applyFilter()
    },
    applyFilter() {
      if (this.portDataSubscribeConfigCompanyList != null && this.portDataSubscribeConfigCompanyList.length > 0) {
        // 过滤符合条件的数据
        const rowData = this.portDataSubscribeConfigCompanyList
        // 中英首字母混排
        this.rowData = rowData.sort((a, b) => {
          const x = a.chineseName ? a.chineseName[0] : ''
          const y = b.chineseName ? b.chineseName[0] : ''
          const reg = /[a-zA-Z0-9]/
          if (reg.test(x) || reg.test(y)) {
            if (x > y) {
              return 1
            } else if (x < y) {
              return -1
            } else {
              return 0
            }
          } else {
            return x.localeCompare(y)
          }
        })
      } else {
        this.rowData = []
      }
    }
  }
}
</script>
<style lang="scss">
#app{
  .rulesCombination{
    .setStyle{
      color: #4283ff;
      .el-form-item__label{
        color: #4283ff !important;
      }
    }
    .businessTypes{
      display: inline-block;
      width: 100%;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #DCDFE6;
      padding-left: 20px;
    }
    .spacing{
      padding: 0 40px 0 0;
      box-sizing: border-box;
      margin-top: 10px;
    }
    .newColumnRule{
      display: flex;
      margin-left:150px;
      .newColumn{
        display: flex;
        justify-content: content;
        align-items: center;
        margin-top:10px;
        .selectCenterWidth{
          width: 80px;
          margin-left:10px;
        }
        .selectWidth{
          width: 30%;
          margin-left:10px;
        }
      }
    }
    .addIcon{
      width: 20px;
      height: 20px;
      background: #f2f6fc;
      display: flex;
      cursor:pointer;
      align-items: center;
      justify-content: center;
    }
    .action{
      margin: 15px 0 0 50px;
      .conditions{
        width: 85px;
        display: inline-block;
      }
    }
    .customer{
      margin:0 20px 0 20px;
      width:300px;
      .conditionsType{
        display:flex;
        align-items: center;
        margin:10px 0 0 20px;
        .title{
          width: 120px;
          margin-right:10px;
        }
      }
    }

    .conditionsTitle{
      margin: 20px 0 0 50px;
    }
    .el-dialog{
      .el-dialog__body{
        padding: 0;
      }
      .app-main-inner-row{
        padding:0 !important;
        display:flex;
        justify-content: flex-start;
      }
    }
  }
}
</style>
